import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { Product, ProductListQuery } from '@kon/shared';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/queryClient';

export function useProducts(query: Partial<ProductListQuery>) {
  return useQuery({
    queryKey: queryKeys.products(query),
    queryFn: ({ signal }) => api.listProducts(query, signal),
    placeholderData: keepPreviousData,
  });
}

export function useFeatured() {
  return useQuery({
    queryKey: queryKeys.featured(),
    queryFn: ({ signal }) => api.listFeatured(signal),
    staleTime: 60_000,
  });
}

export function useProduct(slug: string | undefined) {
  return useQuery<Product>({
    queryKey: queryKeys.product(slug ?? ''),
    queryFn: ({ signal }) => api.getProduct(slug as string, signal),
    enabled: Boolean(slug),
  });
}
